import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { StatusCount } from '@nimmsta/ng-workflow-lib/models';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WorkerDashboardService {
  protected http = inject(HttpClient);


  getData(): Observable<StatusCount[]> {
    return this.http.get<StatusCount[]>(
      `${environment.apiUrls.workflow}/api/v1/dashboard/worker/status-count`,
    );
  }
}
